import { IObjectAudit, IFileSubType } from "../../models"

export interface IFileDocument {
    Id: string
    AccountId: string
    Name: string
    SubType: IFileSubType
    S3Id: string
    FileExtension: string
    ObjectAudit: IObjectAudit
    ObjectContextType: EFileObjectContextType
    ObjectContextId: string
    Deleted: boolean
    TicksSinceChange: number
    PermissionData: IFilePermissionData
    File: IHttpFile
}

export interface IHttpFile {
    Name: string
    MediaType: string
    Buffer: string
}

export interface IFilePermissionData {
    HierarchyId: string
    RequiredAccessPermission: string[]
    AllowRecruiterAccess: boolean
    AllowComplianceManagerAccess: boolean
    AllowSupervisorAccess: boolean
    AllowPayrollManagerAccess: boolean
}

export enum EFileObjectContextType {
    User = 0,
    Client = 1,
    Job = 2
}